import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SectionText',
  props: {
  className: { type: String, required: false, default: 'pt-4' },
},
  setup(__props) {



return { __sfc: true, }
}

})